import __asset_0 from "@app/assets/img/app_icons/parent.png?url&no-inline"
import __asset_1 from "@app/assets/img/app_icons/parent.png?url&no-inline"
import __asset_2 from "@app/assets/spectrum_data.svg"
import type { MapBounds } from '@app/packages/geo/MapBounds'

/** ISO8601 formatted string */
export type ISO8601 = string

export const IPRegex = /^(\d{1,3}\.){3}\d{1,3}$/

export const DEFAULT_EMAIL_PLACEHOLDER = 'someone@example.com'

export const DEFAULT_SCHOOL_PHONE = '8 800 707-80-97'

export const SITTER_REFERRAL_REWARD = 300

export const EXTERNAL_LINKS_REL = 'noopener noreferrer nofollow'
export const EXTERNAL_LINKS_REL_FOLLOW = 'noopener noreferrer'

export const APP_INFO = {
  parent: {
    ios: {
      title: 'Kidsout — свобода на час',
      id: '1273152870',
      url: 'https://apps.apple.com/app/apple-store/id1273152870?pt=118002178&ct=app-promotion&mt=8',
    },
    android: {
      title: 'Kidsout — свобода на час',
      id: 'ru.kidsout.parent',
      url: 'https://play.google.com/store/apps/details?id=ru.kidsout.parent&utm_source=kidsout&utm_medium=landing&utm_campaign=app-promotion',
      image: __asset_0,
      developer: 'Detki v Poryadke',
    },
    galaxy: {
      title: 'Kidsout — свобода на час',
      id: 'ru.kidsout.parent',
      url: 'https://galaxystore.samsung.com/detail/ru.kidsout.parent',
      image: __asset_1,
      developer: 'Detki v Poryadke',
    },
    apk: {
      url: '/apps/android/parent/latest.apk',
    },
  },
}

export const TBANK_REVIEWS_URL = 'https://www.tbank.ru/reviews/company/kidsout/18418/'

/** Codes that are part of ApiError.response.errors[number].code */
export const ERROR_CODES = {
  INVALID_PARAMS: 'INVALID_PARAMS',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  PROMOCODE_ERROR: 'PROMOCODE_ERROR',
} as const

export const MEGAFON_PROMOCODE = 'mf'

export const AUDIT_PROVIDER = {
  name: 'SpectrumData',
  url: 'https://spectrumdata.ru',
  image: __asset_2,
  width: 176,
  height: 55,
}

export const SOCIAL_CONTACTS = {
  youtube: 'https://www.youtube.com/channel/UC9vgKuVMZKxr0cnvb-z3Eeg',
  vk: 'https://vk.com/kidsout_ru',
  instagram_sitter: 'https://www.instagram.com/babysitter.kidsout',
  instagram_parent: 'https://www.instagram.com/kidsout.app',
  facebook: 'https://www.facebook.com/kidsout.ru',
  telegram: 'https://t.me/kidsout_app',
}

export const CHAT_MODE_FAVORITES = 'CHAT_MODE_FAVORITES'

export const CLIENT_ERROR_CODE = 600
export const NETWORK_ERROR_CODE = 610
export const ABORT_ERROR_CODE = 620

/** Pixels of the map the header and the bottom sheet cover on mobile. */
export const MOBILE_MAP_ZOOM_MARGIN: [number, number, number, number] = [70, 18, 82, 18]
export const MOBILE_MAP_CLUSTERER_ZOOM_MARGIN: [number, number, number, number] = [70, 50, 70, 50]

export const DEFAULT_BOUNDS: MapBounds = [
  [55.7522 - 0.1, 37.6156 - 0.2],
  [55.7522 + 0.1, 37.6156 + 0.2],
]

export const DEFAULT_SITTER_SEARCH_SORT = '-kidsout_score'

export const FOUNDING_YEAR = 2014
export const COMPANY_NAME = 'Кидсаут'
export const COMPANY_REGISTRATION_NUMBER = '1104534'
/** DD.MM.YYYY format */
export const COMPANY_REGISTRATION_NUMBER_DATE = '2025.04.10'
export const COMPANY_REGISTRATION_NUMBER_DATE_FORMAT = 'YYYY.MM.DD'

export const GIFTCARDS_ENABLED = false
export const SITTER_SCREENING_ENABLED = API_MODE !== 'production'

export const FRANCHISE_REGIONS_SLUGS = ['ekb', 'krasnoyarsk', 'nn', 'nsk', 'oren', 'rnd', 'sochi', 'tmn']

export const REQUEST_REVIEW_PERIOD_DAYS = 7

export const SITTER_FAQ_MESSAGE_TYPE = 'sitter-faq-29cd52c4-957c-4ae7-9545-1bb382c3efdf'
